export default "__VITE_ASSET__azrIebmC__"